import { HydratedRouter } from 'react-router/dom';
import * as Sentry from '@sentry/react-router';
import { startTransition, StrictMode } from 'react';
import { config } from 'util-config';

// Sentry needs to be initialized before other imports

if (config.SENTRY_DSN) {
  Sentry.init({
    dsn: config.SENTRY_DSN,
    debug: config.SENTRY_DEBUG,
    environment: config.APP_ENV,
    sendDefaultPii: true,
    integrations: [
      Sentry.reactRouterTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, maskAllInputs: true, blockAllMedia: false }),
    ],
    tracesSampleRate: config.SENTRY_TRACING_SAMPLE_RATE,
    replaysSessionSampleRate: config.SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate: config.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
  });
}

import { hydrateRoot } from 'react-dom/client';

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
